import React from "react";
import { FormattedMessage } from "react-intl";

export const DevicesPageTitle = (props) => {
  return (
    <h1 {...props}>
      <FormattedMessage id={"manage_devices"} />
    </h1>
  );
};
